module.exports = __webpack_public_path__ + "static/media/behandeling.1abaf609.svg";